import { createStyles, focusStyle, makeStyles, Theme } from 'ui-components';

const LABEL_COLUMN_WIDTH = 160;
const SETTINGS_LABEL_COLUMN_WIDTH = 220;
const SETTINGS_UNIT_COLUMN_WIDTH = 24;

export default makeStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    padding: 40,
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      padding: 24,
    },

    [theme.breakpoints.down('xs')]: {
      padding: '24px 16px',
    },
  },

  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },

  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
  },

  editButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    padding: 4,
    margin: -4,
    border: 0,
    background: 'none',
    cursor: 'pointer',
    '& path': {
      fill: theme.color.oranges[50],
    },
    '&:focus-visible': {
      ...focusStyle(theme),
    },
  },

  editIcon: {
    width: 16,
    height: 16,
  },

  rows: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    margin: 0,
  },

  row: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 24,
  },

  rowLabel: {
    flex: `0 0 ${LABEL_COLUMN_WIDTH}px`,
    maxWidth: LABEL_COLUMN_WIDTH,

    [theme.breakpoints.down('xs')]: {
      flex: '1 1 auto',
    },
  },

  rowValue: {
    flex: '1 1 auto',
    margin: 0,
    minWidth: 0,

    [theme.breakpoints.down('xs')]: {
      flex: '1 1 auto',
    },
  },

  emptyState: {
    margin: 0,
  },

  settingsRows: {
    gap: 12,
  },

  settingsRow: {
    alignItems: 'center',
  },

  settingsRowLabel: {
    flex: `0 0 ${SETTINGS_LABEL_COLUMN_WIDTH}px`,
    maxWidth: SETTINGS_LABEL_COLUMN_WIDTH,

    [theme.breakpoints.down('xs')]: {
      flex: '1 1 auto',
    },
  },

  settingsRowValue: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flex: '1 1 auto',
    margin: 0,
    minWidth: 0,
  },

  settingsInputWrapper: {
    flex: '1 1 auto',
    minWidth: 0,
  },

  settingsInput: {
    '& .MuiInputBase-root': {
      backgroundColor: theme.color.greys[0],
    },

    '& input': {
      textAlign: 'right',
    },
  },

  settingsUnit: {
    marginTop: 8,
    flexShrink: 0,
    width: SETTINGS_UNIT_COLUMN_WIDTH,
  },

  divider: {
    margin: 0,
  },
}), { name: 'RetirementCalculatorSummary' });
